import { useEffect, useRef, useState } from 'react';

const rows = [
  { before: '会議が多く、時間が奪われる', after: '必要な会議だけに絞られる' },
  { before: '何を決めたか不明確', after: '決定事項が即座に明確になる' },
  { before: '誰が動くか不明', after: 'アクションオーナーが明確になる' },
  { before: '同じ議題が繰り返される', after: '議題が確実に前に進む' },
  { before: '管理職が疲弊している', after: '管理職が本来業務に集中できる' },
  { before: '会議後にまた会議が必要', after: '1回の会議で進展する' },
];

export default function BeforeAfterSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.08 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} id="before-after" className="py-24 px-4 md:px-10" style={{ backgroundColor: '#F5F4F2' }}>
      <div className="max-w-4xl mx-auto">
        <div
          className="text-center mb-12 transition-all duration-700"
          style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(20px)' }}
        >
          <span
            className="inline-block px-3 py-1 text-xs font-bold tracking-widest uppercase text-[#C0392B] border border-[#C0392B]/30 rounded-full mb-4"
            style={{ fontFamily: 'Poppins, sans-serif' }}
          >
            Before / After
          </span>
          <h2
            className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight"
            style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
          >
            設計会議で、どう変わるか
          </h2>
        </div>

        <div
          className="rounded-lg overflow-hidden border border-gray-200 transition-all duration-700"
          style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(24px)', transitionDelay: '0.2s' }}
        >
          {/* Header */}
          <div className="grid grid-cols-2">
            <div className="bg-gray-800 px-6 py-4 flex items-center gap-2">
              <i className="ri-close-circle-line text-red-400 text-lg" />
              <span className="text-sm font-bold text-white" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                BEFORE — 設計なき会議
              </span>
            </div>
            <div className="bg-[#C0392B] px-6 py-4 flex items-center gap-2">
              <i className="ri-checkbox-circle-line text-white text-lg" />
              <span className="text-sm font-bold text-white" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                AFTER — 設計された会議
              </span>
            </div>
          </div>

          {/* Rows */}
          {rows.map((row, i) => (
            <div
              key={i}
              className={`grid grid-cols-2 ${i % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}
            >
              <div className="px-6 py-4 flex items-start gap-3 border-r border-gray-200">
                <i className="ri-close-line text-gray-400 text-base flex-shrink-0 mt-0.5" />
                <span
                  className="text-sm text-gray-500"
                  style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                >
                  {row.before}
                </span>
              </div>
              <div className="px-6 py-4 flex items-start gap-3">
                <i className="ri-check-line text-[#C0392B] text-base flex-shrink-0 mt-0.5" />
                <span
                  className="text-sm text-gray-800 font-medium"
                  style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                >
                  {row.after}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Mid CTA */}
        <div
          className="mt-10 text-center transition-all duration-700"
          style={{ opacity: visible ? 1 : 0, transitionDelay: '0.5s' }}
        >
          <button
            onClick={() => document.querySelector('#cta')?.scrollIntoView({ behavior: 'smooth' })}
            className="px-8 py-3.5 bg-[#C0392B] text-white font-bold text-sm rounded-md hover:bg-[#a93226] transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
          >
            あなたの会議を診断する（無料・5分）
          </button>
        </div>
      </div>
    </section>
  );
}
